import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-custom-edit',
  templateUrl: './custom-edit.component.html',
  styleUrl: './custom-edit.component.scss'
})
export class CustomEditComponent {
  @Output() clickMyButton = new EventEmitter();

  onClick() {
    this.clickMyButton.next(true);
  }
}
